import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-provider-login',
    templateUrl: './block-provider-login.component.html',
})

export class BlockProviderLoginComponent extends BlockAbstractComponent implements OnInit {

}
